import {
	Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild, ElementRef,
	ChangeDetectionStrategy, ChangeDetectorRef
} from '@angular/core';
import { AccountType, GroupDto, GroupTreeDto, UserDto } from 'UvExplorerServer.Dtos.TS/Auth';
import { GroupComponent } from '../group/group.component';
import { MessageService } from 'base';
import { UsersService } from '../../services/users.service';
import { List } from 'DiscoveryEngine.TS/Utils';


@Component({
    selector: 'group-dialog',
	templateUrl: './group-dialog.component.html'
})
export class GroupDialogComponent {

	@Input()
	public visible: boolean;

	@Input()
	public target: GroupDto;

	@Input()
	public create: boolean;

	@Output()
	public visibleChange: EventEmitter<boolean>;

	@Output()
	public onOk: EventEmitter<GroupDto>;

	@Output()
	public onCancel: EventEmitter<any>;

	public users: UserDto[];

    @ViewChild(GroupComponent, { static: true })
	public group: GroupComponent;

	private buttonClicked: boolean;

	constructor(private usersService: UsersService,
		private messageService: MessageService,
		private changeDetector: ChangeDetectorRef) {

		this.visible = false;
		this.target = null;
		this.create = false;
		this.visibleChange = new EventEmitter<boolean>();
		this.onOk = new EventEmitter<GroupDto>();
		this.onCancel = new EventEmitter<any>();
		this.users = [];
		this.buttonClicked = false;
	}

	public get enableOk(): boolean {
		return this.group.enableApply;
	}

	public get dialogTitle(): string {
		return (this.create ? "Create Group" : "Edit Group");
	}

	public show(): void {
		this.visible = true;
		this.visibleChange.emit(true);

		this.changeDetector.markForCheck();
	}

	public hide(): void {
		this.visible = false;
		this.visibleChange.emit(false);

		this.changeDetector.markForCheck();
	}

	public onDialogHide(): void {
		if (this.buttonClicked) {
			this.buttonClicked = false;
		}
		else {
			this.doCancelActions();
		}
	}

	public onCancelClicked(): void {
		this.buttonClicked = true;
		this.doCancelActions();
	}

	private doCancelActions(): void {
		this.hide();
		this.onCancel.emit();
	}

	public onOkClicked(): void {
		let isUpdate = !this.create;
		if (isUpdate && !this.updateIsSafe()) {
			this.messageService.displayErrorMessage("Cannot remove last administrator");
		}
		else {
			this.apply();
		}
	}

	private updateIsSafe(): boolean {
		return true;
	}

	private apply(): void {
		if (this.target) {
			this.group.applyTempChanges();

			if (this.create) {
				let parentGroup = this.usersService.groupTree.RootGroup;
				if (parentGroup) {
					this.usersService.createGroup(this.target, parentGroup.Guid, -1).subscribe(
						(result: GroupDto) => {
							this.buttonClicked = true;
							this.hide();
							this.onOk.emit(result);
							this.messageService.displayInfoMessage("Group successfully created");
						},
						(error) => {
							this.messageService.displayErrorMessage("Creating group failed");
						});
				}
				else {
					this.messageService.displayErrorMessage("Could not create the group (parent group not found)");
				}
			}
			else {
				this.usersService.updateGroup(this.target).subscribe(
					(result: GroupDto) => {
						this.buttonClicked = true;
						this.hide();
						this.onOk.emit(result);
						this.messageService.displayInfoMessage("Group successfully updated");
					},
					(error) => {
						this.messageService.displayErrorMessage("Updating group failed");
					});
			}
		}
	}

	public ngOnChanges(changes: SimpleChanges): void {

		if (changes["visible"]) {
			if (this.visible) {
				this.usersService.getAllUsers().subscribe(
					(result: List<UserDto>) => {
						this.users = result.ToArray();
					},
					(error) => {
						console.error(error);
						this.messageService.displayErrorMessage("Could not retrieve users");
					}
				);
			}
		}

	}

}
